import React, { useState } from "react";
import "./toolTip.scss";

const Tooltip = ({ text, position = "top", children }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="tooltipContainer">
      <div
        className="tooltipTrigger"
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
      >
        {children}
      </div>

      {visible && (
        <div className={`tooltipBox tooltip-${position}`}>
          {text}
          <div className={`tooltipArrow tooltipArrow-${position}`}></div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
